// src/styles.js
const styles = {
  paddingX: "sm:px-16 px-6",
  paddingY: "sm:py-16 py-6",
  padding: "sm:px-16 px-6 sm:py-16 py-10",

  heroHeadText:
    "font-black text-[#915EFF] lg:text-[80px] sm:text-[60px] xs:text-[50px] text-[40px] lg:leading-[98px] mt-2",
  heroSubText:
    "text-[#dfd9ff] font-medium lg:text-[45px] sm:text-[26px] xs:text-[20px] text-[16px] lg:leading-[40px] font-vina", // Se usa la clase font-vina
  heroSupText:
    "text-[#dfd9ff] font-medium lg:text-[35px] sm:text-[16px] xs:text-[20px] text-[16px] lg:leading-[45px] font-caramel", // Se usa la clase font-vina
  heroHeadText2:
    "font-black text-[#915EFF] lg:text-[22px] sm:text-[60px] xs:text-[50px] text-[40px] lg:leading-[98px] mt-2",
  heroSup2Text:
    "text-[#dfd9ff] font-medium lg:text-[50px] sm:text-[26px] xs:text-[20px] text-[16px] lg:leading-[60px] font-anton", // Se usa la clase font-vina
heroSup3Text:
    "text-[#915EFF] font-medium lg:text-[50px] sm:text-[26px] xs:text-[20px] text-[16px] lg:leading-[60px] font-anton", // Se usa la clase font-vina
heroSup4Text:
    "text-[#915EFF] font-medium lg:text-[50px] sm:text-[26px] xs:text-[20px] text-[16px] lg:leading-[60px] font-anton", // Se usa la clase font-vina

    bodyText:
    "font-inter text-black  tracking-wide " +
    "md:text-[20px] sm:text-[18px] xs:text-[17px] text-[16px] " +
    "leading-relaxed mb-6",   // 👈  separa 1.5 rem (24 px aprox.)

    sectionHeadText:
    "text-white font-black md:text-[80px] sm:text-[60px] xs:text-[45px] text-[35px] font-anton",  
  sectionHeadText2:
    "text-black font-black md:text-[65px] sm:text-[50px] xs:text-[40px] text-[30px] font-anton",
  sectionHeadText3:
    "text-black font-white md:text-[22px] sm:text-[20px] xs:text-[20px] text-[20px] font-caramel",
  sectionSubText:
    "sm:text-[18px] text-[14px] text-secondary uppercase tracking-wider",
};

export { styles };
